<template>
  <div class="faq_content-components">
    <div class="faq_content">
      <div class="number Longfont">
        <span>{{number}}</span>
      </div>
      <div class="text">
        <p class="question">
          {{question}}
        </p>
        <p class="answer">
          {{answer}}
        </p>
        <slot>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqContent',
  props: {
    number: String,
    question: String,
    answer: String,
  }
}
</script>
<style scoped lang="scss">
.faq_content-components + .faq_content-components {
  margin-top: 50px;
}
.faq_content {
  margin: 0 auto;
  font-size: 12px;
  display: flex;
  max-width: 750px;
  width: 100%;
  margin-bottom: 5px;
  @media print, screen and (max-width: 750px) {
    flex-direction: column;
  }
}
.number {
  display: flex;
  background-color: #e51c57;
  height: 110px;
  width: 110px;
  justify-content: center;
  align-items: center;
  position: relative;
  @media print, screen and (max-width: 750px) {
    height: 60px;
    width: 60px;
    margin-bottom: 30px;
  }
  &:after {
    content: "";
    width: 0;
    height: 0;
    display: block;
    border: 10px solid transparent;
    position: absolute;
    @media print, screen and (min-width: 751px) {
      border-left: 15px solid #e51c57;
      right: -25px;
    }
    @media print, screen and (max-width: 750px) {
      border-top: 15px solid #e51c57;
      bottom: -25px;
    }
  }
  span {
    color: #fff;
    display: block;
    font-size: 24px;
  }
}
.text {
  @media print, screen and (min-width: 751px) {
    margin-left: 50px;
  }
}
.question {
  font-size: 20px;
  color: #e51c57;
  @media print, screen and (max-width: 750px) {
    font-size: 14px;
  }
  &:before {
    content: url('../../assets/img/faq/q.svg');
    width: 1.5em;
    display: inline-block;
    vertical-align: middle;
    margin-right: 1em;
  }
}
.answer {
  font-size: 20px;
  color: #2293c9;
  @media print, screen and (max-width: 750px) {
    font-size: 14px;
  }
  &:before {
    content: url('../../assets/img/faq/a.svg');
    width: 1.5em;
    display: inline-block;
    vertical-align: middle;
    margin-right: 1em;
  }
}
</style>
